module.exports = __webpack_public_path__ + "static/img/adulticide.2e1b5cf.svg";